/**
 * Back-to-top button.
 * Mirrors live behavior: becomes visible once the page is scrolled past one
 * viewport height, and smooth-scrolls to the top on click.
 */
class ScrollTopButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    this.button.classList.toggle('is-visible', window.scrollY > window.innerHeight);
  }

  onClick() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('scroll-top-button')) {
  customElements.define('scroll-top-button', ScrollTopButton);
}
